import type { TemplateRef } from '@angular/core';
import type { CompanyColumnDef } from './grid-column.types';
import type { GridConfig } from './grid-config.types';

/**
 * Port da arquitetura hexagonal: contrato único que qualquer motor de renderização
 * deve implementar. Nenhum código fora de `bridges/*` pode depender do motor concreto.
 */
export abstract class GridBridge<T = unknown> {
  // ── Dados ─────────────────────────────────────────────────────────────────
  abstract setColumns(columns: readonly CompanyColumnDef<T>[]): void;
  abstract setRowData(rows: readonly T[]): void;
  abstract setLoading(loading: boolean): void;

  // ── Seleção ───────────────────────────────────────────────────────────────
  abstract setSelectionMode(mode: 'single' | 'multiple' | 'none'): void;
  abstract setSelectedRows(rows: readonly T[]): void;

  // ── Colunas ───────────────────────────────────────────────────────────────
  abstract setColumnVisible(field: string, visible: boolean): void;

  // ── Filtro global ─────────────────────────────────────────────────────────
  abstract setGlobalFilter(term: string): void;

  // ── Exportação / utilitários ──────────────────────────────────────────────
  abstract exportToCsv(fileName: string): void;
  abstract sizeColumnsToFit(): void;

  // ── Configuração visual (batch) ────────────────────────────────────────────
  /**
   * Aplica toda a configuração de exibição de uma só vez.
   * Substitui os antigos `setShowPagination()` e `setAutoHeight()`.
   */
  abstract configure(config: GridConfig): void;

  // ── Template de expansão ──────────────────────────────────────────────────
  abstract setExpandTemplate(template: TemplateRef<unknown> | null): void;
}
